import React from 'react'
import { Card, CardBody } from './Card'
import { Badge } from './Badge'

interface StatCardProps {
  label: string
  value: string | number
  delta?: string
  deltaPositive?: boolean
  icon?: React.ReactNode
  live?: boolean
  loading?: boolean
}

export function StatCard({ label, value, delta, deltaPositive = true, icon, live = false, loading = false }: StatCardProps) {
  return (
    <Card>
      <CardBody>
        <div className="flex items-start justify-between mb-3">
          <span className="text-xs font-semibold text-text-muted uppercase tracking-wider">{label}</span>
          <div className="flex items-center gap-2">
            {live && <Badge variant="live" pulse>LIVE</Badge>}
            {icon && <div className="text-text-muted">{icon}</div>}
          </div>
        </div>
        {loading ? (
          <div className="h-8 w-24 bg-surface-overlay rounded animate-pulse" />
        ) : (
          <div className="text-3xl font-bold text-text-primary tabular-nums">{value}</div>
        )}
        {delta && !loading && (
          <div className={`mt-2 text-xs font-medium ${deltaPositive ? 'text-brand-success' : 'text-brand-danger'}`}>
            {deltaPositive ? '↑' : '↓'} {delta}
          </div>
        )}
      </CardBody>
    </Card>
  )
}
